<template>
  <v-container class="fill-height login-page" fluid>
    <v-row align="center" justify="center">
      <v-col cols="10" align="center">
        <v-sheet class="login-box" color="#ffffff" max-width="400">
          <v-row align="center" justify="center">
            <v-col cols="6">
              <v-img src="images/logo.png" width="150" />
            </v-col>
          </v-row>
          <v-alert v-if="!$route.query.token" type="error">
            Wrong URL
          </v-alert>
          <div v-else>
            <v-row align="center" justify="center">
              <v-col
                cols="8"
                class="light-grey subtitle-2"
                v-if="!isStatusSuccess"
              >
                Enter your new password
              </v-col>
            </v-row>
            <v-alert color="green" dark v-if="isStatusSuccess"
              ><small
                >Successfully updated. Please
                <a text :href="loginUrl + '/login'" class="success-link"
                  >login</a
                ></small
              ></v-alert
            >
            <v-row align="center" justify="center">
              <v-col cols="11">
                <v-form
                  ref="passwordForm"
                  v-model="passwordValid"
                  @submit.prevent="updatePassword"
                  @keyup.enter.native="updatePassword"
                >
                  <v-text-field
                    ref="newPassword"
                    type="password"
                    v-model="newPassword"
                    :disabled="isStatusSuccess"
                    :rules="passwordRules"
                    label="New Password"
                    required
                    @keyup.native="validatePasswordForm"
                  ></v-text-field>
                  <v-text-field
                    type="password"
                    v-model="confirmPassword"
                    :disabled="isStatusSuccess"
                    :rules="passwordMatchRules"
                    label="Confirm Password"
                    required
                    @keyup.native="validatePasswordForm"
                  ></v-text-field>
                  <Errors
                    :errors="
                      secureRestoreResetErrors.errors
                        ? secureRestoreResetErrors.errors
                        : {}
                    "
                  ></Errors>
                  <div class="text-right">
                    <v-btn
                      :disabled="
                        isStatusLoading || isStatusSuccess || !passwordValid
                      "
                      color="success"
                      :loading="isStatusLoading"
                      @click="updatePassword"
                    >
                      Update Password
                    </v-btn>
                  </div>
                </v-form>
              </v-col>
            </v-row>
          </div>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import actionTypes from "@/vuex/action-types";
import * as constants from "@/common/constants";
import Errors from "@/components/Errors";

export default {
  name: "ResetPassword",
  components: {
    Errors
  },
  computed: {
    ...mapGetters([
      "secureRestoreResetStatus",
      "secureRestoreResetErrors",
      "isLoggedIn"
    ]),
    isSecureError() {
      return this.secureRestoreResetStatus === constants.STATUS_ERROR;
    },
    isStatusLoading() {
      return this.secureRestoreResetStatus === constants.STATUS_LOADING;
    },
    isStatusSuccess() {
      return this.secureRestoreResetStatus === constants.STATUS_SUCCESS;
    },
    loginUrl() {
      return process.env.VUE_APP_ENV_LOGIN_URL;
    }
  },
  data() {
    return {
      passwordValid: false,
      newPassword: "",
      passwordRules: [
        v =>
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_=+])(?=.{8,})/.test(
            v
          ) ||
          "Min. 8 characters with at least one capital letter, a number and a special character"
      ],
      confirmPassword: "",
      passwordMatchRules: [v => v === this.newPassword || "Password must match"]
    };
  },
  methods: {
    ...mapActions([
      actionTypes.PASSWORD_RESTORE_RESET,
      actionTypes.OPEN_LOGIN,
      actionTypes.LOGOUT
    ]),
    validatePasswordForm() {
      this.$refs.passwordForm.validate();
    },
    updatePassword: function() {
      if (this.passwordValid) {
        const token = this.$route.query.token;
        const password = this.newPassword;
        this[actionTypes.PASSWORD_RESTORE_RESET]({ token, password });
      }
    }
  },
  mounted() {
    if (this.isLoggedIn) {
      this[actionTypes.LOGOUT]();
    }
    if (this.$route.query.token) {
      this.$nextTick(() => this.$refs.newPassword.focus());
    }
  }
};
</script>
